// removed by extract-text-webpack-plugin
module.exports = {"focus":"Focus__focus___2vOJa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cells/Cells/Prefilled/Focus.css
// module id = 845
// module chunks = 0